import { render } from "./AtendimentoProfRelatorio.vue?vue&type=template&id=b591f106&scoped=true"
import script from "./AtendimentoProfRelatorio.vue?vue&type=script&lang=js"
export * from "./AtendimentoProfRelatorio.vue?vue&type=script&lang=js"

import "./AtendimentoProfRelatorio.vue?vue&type=style&index=0&id=b591f106&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b591f106"]])

export default __exports__